import Div from "@jumbo/shared/Div/Div";
import {Box, Paper, Tab, Tabs} from "@mui/material";
import TabPanel from "app/pages/Docgen/components/common/mui-tabpanel/MuiTabpanel";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {post} from "../../../common/network";
import Notes from "../modify-matter/NotesTab";
import MatterContacts from "./MatterContacts";
import MatterDetails from "./MatterDetails";
import "./CreateMatter.css";
import RelatedMatters from "./RelatedMatters";

const CreateMatter = ({handleClose}) => {
    //#region for states
    const [activeTab, setActiveTab] = useState(0);
    const [collapse1, setCollapse1] = useState(false);
    const [collapse2, setCollapse2] = useState(false);

    // Forms section data
    const [mattersDetails, setMattersDetails] = useState(null);
  const [note, setNote] = useState(null);
    const [contactsData, setContactsData] = useState({});
    const [savedContactsData, setSavedContactsData] = useState({});
    const [priorApplicationData, setPriorApplicationData] = useState({});
    const [formikObj, setFormikObj] = useState({});
    const [savedContactObj, setSavedContactObj] = useState({});
    const [priorFormikObj, setPriorFormikObj] = useState({});
    const [matterId, setMatterId] = useState(null);
    const [combinedMatterData, setCombinedMatterData] = useState({});
    const [loading, setLoading] = useState(false);
    //#endregion

    useEffect(() => {
        setContactsData(savedContactsData);
    }, [activeTab]);

    const setNewNote = async notes => {
        setLoading(true);
        try {
            const response = await post(`docgen/matters`, {...combinedMatterData, notes});
            if (response?.success === true) {
                toast.success(response.message);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content-wrapper">
            <Box className="w-100">
                <div>
                    <Paper>
                        <Div>
                            <Tabs
                                value={activeTab}
                                onChange={(event, newValue) => {
                                    setActiveTab(newValue);
                                }}
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                aria-label="scrollable force tabs example"
                                className="mui-tab-header sticky-header"
                            >
                                <Tab label="Docket Details"/>
                                <Tab
                                    label="Contacts"
                                    disabled={!matterId}
                                    title={!matterId ? "Click on Save & Next" : ""}
                                    style={!matterId ? {cursor: "not-allowed", pointerEvents: "auto"} : {}}
                                />
                                <Tab
                                    label="Related Matters"
                                    disabled={!matterId}
                                    title={!matterId ? "Click on Save & Next" : ""}
                                    style={!matterId ? {cursor: "not-allowed", pointerEvents: "auto"} : {}}
                                />
                                <Tab label="Notes"
                                     disabled={!matterId}
                                     title={!matterId ? "Click on Save & Next" : ""}
                                     style={!matterId ? {cursor: "not-allowed", pointerEvents: "auto"} : {}}
                                />

                            </Tabs>
                            <TabPanel value={activeTab} index={0}>
                                <MatterDetails
                                    collapse1={collapse1}
                                    setCollapse1={setCollapse1}
                                    collapse2={collapse2}
                                    setCollapse2={setCollapse2}
                                    setActiveTab={setActiveTab}
                                    setFormData={setMattersDetails}
                                    formData={mattersDetails}
                                    setMatterId={setMatterId}
                                    matterId={matterId}
                                    setCombinedMatterData={setCombinedMatterData}
                                />
                            </TabPanel>
                            <TabPanel value={activeTab} index={1}>
                                <MatterContacts
                                    setActiveTab={setActiveTab}
                                    contactsData={contactsData}
                                    setContactsData={setContactsData}
                                    formikObj={formikObj}
                                    setFormikObj={setFormikObj}
                                    handleClose={handleClose}
                                    matterId={matterId}
                                    combinedMatterData={combinedMatterData}
                                    setCombinedMatterData={setCombinedMatterData}
                                    savedContactsData={savedContactsData}
                                    setSavedContactsData={setSavedContactsData}
                                    savedContactObj={savedContactObj}
                                    setSavedContactObj={setSavedContactObj}
                                />
                            </TabPanel>
                            <TabPanel value={activeTab} index={2}>
                                <RelatedMatters
                                    setActiveTab={setActiveTab}
                                    priorApplicationData={priorApplicationData}
                                    setPriorApplicationData={setPriorApplicationData}
                                    formikObj={priorFormikObj}
                                    setFormikObj={setPriorFormikObj}
                                    handleClose={handleClose}
                                    matterId={matterId}
                                    combinedMatterData={combinedMatterData}
                                    setCombinedMatterData={setCombinedMatterData}
                                />
                            </TabPanel>
                            <TabPanel value={activeTab} index={3}>
                                <Notes
                                    note={note}
                                    id={matterId}
                                    setNote={value => {
                                        setNote(value);
                                    }}
                                    onSubmit={values => {
                                        setNewNote(values);
                                    }}
                                    loading={loading}
                                    handleClose={handleClose}
                                />
                            </TabPanel>
                        </Div>
                    </Paper>
                </div>
            </Box>
        </div>
    );
};

export default CreateMatter;